import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  ViewChild,
  OnDestroy,
  ElementRef,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { AgentDetailComponent } from "@app/modules/agent/pages/agent-detail/agent-detail.component";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { PopoverDirective } from "ngx-bootstrap/popover";
import * as _ from "lodash";
import { HelperService } from "@app/core/services/helper.service";
import { NgxLinkifyjsService } from 'ngx-linkifyjs';
import { ShareUpdateComponent } from '../share-update/share-update.component';
import { PostReferralComponent } from '../post-referral/post-referral.component';
import { AuthenticationService } from '@app/core/services/authentication.service';
import { AppConfig } from '@app/core/Utilities/app-config.service';
import { ResultStatus } from '@app/core/models/result-status';
import { CommunityService } from '@app/core/services/community.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: "app-post-item-view",
  templateUrl: "./post-item-view.component.html",
  styleUrls: ["./post-item-view.component.scss"],
})
export class PostItemViewComponent implements OnInit, OnChanges, OnDestroy {
  @Input() postList: any;
  @Input() hasReportedPost: boolean;
  // This component makes a request but it can't actually do any action.
  @Output() likeRequest = new EventEmitter();
  @Output() shareRequest = new EventEmitter();
  @Output() bookmarkRequest = new EventEmitter();
  @Output() deleteCommunityPost = new EventEmitter();
  @Output() changeFilter = new EventEmitter();
  @Output() approvedRejectPost = new EventEmitter();
  @Output() updatePost = new EventEmitter();
  @Output() reportPost = new EventEmitter();
  @ViewChild("popoverRef") private _popoverRef: PopoverDirective;
  @ViewChild("deleteMessageTemplate") deleteMessageTemplate: ElementRef;

  public bsModalRef: BsModalRef;
  public tags = [];
  selectedGroupId: any;
  selectedTag: "";
  selectedfeedId: any;
  links: any[];
  postLink: any[];
  hasLink: boolean;
  loginUserID: any;
  isDeleteAllow = false;
  isEditable = false;
  isReportAllow = false;

  constructor(
    private sanit: DomSanitizer,
    private modalService: BsModalService,
    private helperService: HelperService,
    private router: Router,
    private route: ActivatedRoute,
    public linkifyService: NgxLinkifyjsService,
    private authService: AuthenticationService,
    public appConfig: AppConfig,
    public communityService: CommunityService,
    public toaterService: ToastrService
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (!this.helperService.isUndefinedOrNullOrEmpty(params.groupId)) {
        this.selectedGroupId = params.groupId;
      }
      if (!this.helperService.isUndefinedOrNullOrEmpty(params.tag)) {
        this.selectedTag = params.tag;
      }
      if (!this.helperService.isUndefinedOrNullOrEmpty(params.feedId)) {
        this.selectedfeedId = params.feedId;
      }
    });

    this.loginUserID = +this.authService.getUserInformation()["ID"];
    this.isDeleteAllow = this.postList.CreatedBy === this.loginUserID || this.isModeratorGroupAdmin(this.postList.GroupId);
    this.isReportAllow = !this.isModeratorGroupAdmin(this.postList.GroupId) && this.postList.CreatedBy !== this.loginUserID;
    this.isEditable = this.postList.CreatedBy === this.loginUserID ||
      (this.postList.PostTypeId === 1 && this.isModeratorGroupAdmin(this.postList.GroupId));
  }

  ngOnDestroy() {
    if (this.bsModalRef) {
      this.unsubscribeModalHideEvent();
      this.bsModalRef.hide();
    }
  }

  isModeratorGroupAdmin(groupId): boolean {
    if (this.appConfig.SharedComponent.loggedInUserInfo != null) {
      return _.includes(this.appConfig.SharedComponent.loggedInUserInfo["ModeratorGroupId"], groupId);
    }
    return false;
  }

  getImgsSanitized(imageURL: any) {
    if (imageURL) {
      return this.sanit.bypassSecurityTrustStyle(
        "url(" + imageURL + "), url(/assets/images/user-icon.png)"
      );
    } else {
      return this.sanit.bypassSecurityTrustStyle(
        "url(/assets/images/user-icon.png)"
      );
    }
  }

  splitTags() {
    this.tags = _.split(this.postList.Tag, "#");
  }

  ngOnChanges() {
    this.splitTags();
    if (this.helperService.isUndefinedOrNullOrEmpty(this.postList.PostLink)) {
      this.hasLink = true;
      this.links = this.linkifyService.find(this.postList.Description);
    } else {
      this.hasLink = false;
      this.postLink = this.postList.PostLink;
    }
  }

  viewDetail(id) {
    this.router.navigate([`/community/post/detail/${id}`], {
      queryParams: {
        groupId: this.selectedGroupId,
        tag: this.selectedTag
      },
    });
  }

  openModalWithComponent(agentID) {
    if (agentID > 0) {
      const initialState = {
        agentId: agentID,
      };

      this.modalService.config.class = "modal-xl";
      this.bsModalRef = this.modalService.show(AgentDetailComponent, {
        initialState,
        backdrop: 'static',
        class: "modal-xl",
      });
      this.bsModalRef.content.closeBtnName = "Close";
    }
  }

  editPost(postId, postTypeId) {
    if (postTypeId === 2 || postTypeId === 1) {
      this.bsModalRef = this.modalService.show(ShareUpdateComponent, {
        initialState: { postID: postId },
        class: "modal-lg",
        backdrop: "static",
      });
      this.bsModalRef.content.closeBtnName = "Close";
      this.subscribeModalHideEvent();
    } else {
      this.bsModalRef = this.modalService.show(PostReferralComponent, {
        initialState: { postID: postId },
        class: "modal-lg",
        backdrop: "static",
      });
      this.bsModalRef.content.closeBtnName = "Close";
      this.subscribeModalHideEvent();
    }
  }

  subscribeModalHideEvent() {
    this.modalService.onHide.subscribe(() => {
      this.updatePost.emit(this.postList.ID);
    });
  }

  unsubscribeModalHideEvent() {
    if (this.bsModalRef) {
      this.modalService.onHide.unsubscribe();
    }
  }

  openDeleteConfirmation() {
    this.bsModalRef = this.modalService.show(
      this.deleteMessageTemplate,
      Object.assign({}, { class: "modal-lg" })
    );
  }

  muteCommunityPost(postId, isMute) {
    this.communityService
      .muteCommunityPost(postId, isMute)
      .subscribe((result) => {
        if (result.Status === ResultStatus.Success) {
          if (isMute) {
            this.toaterService.success("Post is Muted successfully");
          }
          this.updatePost.emit(postId);
        }
      });
  }

  reportPostById(postId) {
    this.communityService.reportCommunityPost(postId).subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.toaterService.success("Post reported successfully");
        this.reportPost.emit(postId);
      }
    });
  }

  like(id, isLike, likeId) {
    const outValue = {
      ID: id,
      IsLike: isLike,
      LikeID: likeId,
    };
    this.likeRequest.emit(outValue);
  }

  sharePost(id) {
    this.shareRequest.emit(id);
  }

  bookmark(id, isBookmark, bookmarkId) {
    const outValue = {
      ID: id,
      IsBookmark: isBookmark,
      BookmarkID: bookmarkId,
    };
    this.bookmarkRequest.emit(outValue);
  }

  deletePost() {
    this.deleteCommunityPost.emit(this.postList.ID);
  }

  approvedRejectCommunityPost(id, isApprove) {
    this.approvedRejectPost.emit({ PostId: id, IsApprove: isApprove });
  }

  close() {
    this._popoverRef.hide();
  }

  loadPostbyGroup(id, name) {
    this.changeFilter.emit({ Id: id, Name: name });
  }

  filterTag(tag) {
    this.changeFilter.emit({ Tag: tag });
  }

  getFileExtension(fileName: string) {
    if (!this.helperService.isUndefinedOrNullOrEmpty(fileName)) {
      const re = /(?:\.([^.]+))?$/;
      const ext = re.exec(fileName)[1];
      return `video/${ext}`;
    }
  }
}
